
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import StepIndicator from "./StepIndicator";

const StudioV2Layout: React.FC = () => {
  const location = useLocation();
  const currentStep = parseInt(location.pathname.split("/").pop() || "1");

  // Scroll to top when navigating between steps
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  // Step 5 (Chef's Table / Review) doesn't show the step indicator
  const showStepIndicator = currentStep >= 1 && currentStep <= 4;

  return (
    <div className="min-h-[100dvh] bg-gradient-to-br from-orange-50 via-yellow-50 to-pink-50 flex flex-col">
      {showStepIndicator && <StepIndicator currentStep={currentStep} />}
      <div className="flex-1 w-full px-2 sm:px-4 pb-28 md:pb-8">
        <Outlet />
      </div>
    </div>
  );
};

export default StudioV2Layout;
